import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const mobilequeriesApi = createAsyncThunk(
  "mobileQueries",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    // const response = await axiosInstance.get("/queryList",{ params });
    const response = await axiosInstance.get("/queries", { params });
    return response.data;
  }
);

const mobileQueriesSlice = createSlice({
  name: "mobileQueries",
  initialState: {
    mobileQueries: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mobilequeriesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mobilequeriesApi.fulfilled, (state, action) => {
        state.mobileQueries = action.payload;
        state.loading = false;
      })
      .addCase(mobilequeriesApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mobileQueriesSlice.reducer;
